import { useAlunoContext } from '../../../../../context/AlunoContext';
import { IHoraUnidadeCleanDTO, IMatriculaCustomDTO, ITurmaOfferDTO } from '../../../../../models/happy-code-api.model';
import useCheckIfPageIsUpgrade from '../../../../../globalHooks/matricula/use-check-if-page-is-upgrade.hook';
import useCalcularSaldoTempoContrato from './use-calcular-saldo-tempo-contrato.hook';
import { calcularMesesComDecimais, minutesToHour } from '../../../../../util/render-minutes-to-hour.util';

interface UseCalcularTotalTurmaOfertaProps {
	ofertaData: IHoraUnidadeCleanDTO;
	idTipoNegocio: number;	
}

export default function useCalcularTotalTurmaOferta({
	ofertaData,
	idTipoNegocio,	
}: UseCalcularTotalTurmaOfertaProps) {
	const { matricula } = useAlunoContext();

	const { isUpgradePage } = useCheckIfPageIsUpgrade();

	const { calcularSaldoTempoContrato } = useCalcularSaldoTempoContrato();	

	const calcularTotalTurmaOferta = (): number => {
		const curta = matricula?.turmas?.filter((tipo) => tipo?.turma?.curriculoNegocioCodigo === 'CUR');
		const colonia = matricula?.turmas?.filter((tipo) => tipo?.turma?.curriculoNegocioCodigo === 'COL');
		const escola = matricula?.turmas.filter((tipo) => tipo?.turma?.curriculoNegocioCodigo === "HES");

		const curriculo = matricula?.turmas.filter(
			(tipo) =>
				tipo?.turma?.curriculoNegocioCodigo !== "CUR" &&
				tipo?.turma?.curriculoNegocioCodigo !== "COL" &&
				tipo?.turma?.curriculoNegocioCodigo !== "HES"
		);

		const duracoes = curriculo.map(
			(duracao) => duracao.turma.curriculo.duracaoTotal
		);

		const totalDuracao = duracoes.reduce((acc, duracao) => acc + duracao, 0);

		let valorTotal = 0;

		if (curta.length > 0) {
			valorTotal += curta.length * ofertaData?.valorOfertaCurta;
		}

		if (colonia.length > 0) {
			valorTotal += colonia.length * ofertaData?.valorOfertaColonia;
		}

		if (escola.length > 0) {
			valorTotal += (escola.length * ofertaData?.valorOfertaEscola) * 12;
		}

		const { saldoTempoContrato } = calcularSaldoTempoContrato();

		const totalInstallments = isUpgradePage ? saldoTempoContrato : 12;

		if (totalDuracao === 90) {
			valorTotal += ofertaData?.valorOfertaUmaHoraMeia * totalInstallments;
		}

		if (totalDuracao === 180) {
			valorTotal += ofertaData?.valorOfertaTresHora * totalInstallments;
		}

		if (totalDuracao === 270) {
			valorTotal += ofertaData?.valorOfertaQuatroHoraMeia * totalInstallments;
		}

		if (totalDuracao === 360) {
			valorTotal += ofertaData?.valorOfertaSeisHora * totalInstallments;
		}

		if (totalDuracao > 360) {
			const horasExcedentes = totalDuracao - 360;
			valorTotal += (ofertaData?.valorOfertaSeisHora + ((horasExcedentes / 90) * ofertaData?.valorAdicionalOferta)) * totalInstallments;
		}

		return valorTotal;
	};

	/* calculo 
		periodicidade semanal = 2
		horas = 1 por dia 
		valor hora = 100,00
		tempo de contrato = 6 meses
		|2hs por semana| valor hora | tempo de contrato| total
		    (2 * 1)    *   100,00   *        6 =          1200,00
		 
	*/

	const calcularSeparadamente = (turmaOffer: ITurmaOfferDTO):number => {
		const valorSemana = minutesToHour(turmaOffer.turma.curriculo.negocio.horaSemanal) * ofertaData?.valorUmaHoraCb;		
		const valorTotal = valorSemana * calcularMesesComDecimais(turmaOffer.turma.vigenciaContrato?.dias);	

		return valorTotal;
	}

	const calcularTotalTurmaOfertaCb = ():number => {
		
		const regular = matricula?.turmas?.filter((tipo) => tipo?.turma?.curriculoNegocioCodigo === 'CBO');
		const vip = matricula?.turmas?.filter((tipo) => tipo?.turma?.curriculoNegocioCodigo === 'CBV');
		
		let valorTotal = 0;
		

		valorTotal += regular.reduce((acc, turma) => 
			acc + calcularSeparadamente(turma), 0);		

		valorTotal += vip.reduce((acc, turma) => 
			acc + calcularSeparadamente(turma), 0);		
		
		return valorTotal;
	}

	const calularValorTotalComBaseNoNegocio = (): number => {
		switch (idTipoNegocio) {
			case 1:
				return calcularTotalTurmaOferta();
			case 2:	
				return calcularTotalTurmaOfertaCb();
			default:
				return calcularTotalTurmaOferta();
		}	
	}

	return {
		calularValorTotalComBaseNoNegocio
	};
}
